// extracted by mini-css-extract-plugin
module.exports = {"modalGoodBye":"GoodByeModal_modalGoodBye__2j7Vx","modalFooterText":"GoodByeModal_modalFooterText__1wrdU"};